import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
// ------------------swiper------------------
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';
import './../assets/styles/newArrivals.scss';
import shopingCardData from './data/shopingCardData.json';
import { useWishlist } from '../context/WishlistContext.jsx';
import { FaHeart, FaRegHeart } from 'react-icons/fa';

const NewArrivals = () => {
    const navigate = useNavigate();
    const { toggleWishlist, isInWishlist } = useWishlist();
    const [filter, setFilter] = useState('All');
    const [products, setProducts] = useState([]);

    const categories = ['All', 'Men', 'Women', 'Accessories', 'Trending'];

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });

        // Filter to include only items marked specifically as new item
        const newItemsList = shopingCardData.shopingCard.filter(item => item.newItem === true);

        // Simulating enhanced data with better categories for this page
        const enhancedData = newItemsList.map((item, index) => ({
            ...item,
            // Assigning some random categories for the demo since the JSON is limited
            pageCategory: index % 2 === 0 ? 'Men' : 'Women',
            isTrending: index < 4
        }));
        setProducts(enhancedData);
    }, []);

    const filteredProducts = products.filter(item => {
        if (filter === 'All') return true;
        if (filter === 'Trending') return item.isTrending;
        return item.pageCategory === filter;
    });

    return (
        <div className="new-arrivals-page padding_t88">
            {/* Luxury Hero Section */}
            <section
                className="luxury-hero"
                style={{
                    background: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/inner-banner-3.jpg')`,
                    backgroundSize: 'cover',
                }}
            >
                <Container>
                    <div className="hero-content">
                        <span className="reveal-tag" data-aos="fade-down">The 2026 Collection</span>
                        <h1 className="hero-title">
                            NEW <span>ARRIVALS</span>
                        </h1>
                        <p className="lead text-white-50 col-lg-6" data-aos="fade-up" data-aos-delay="400">
                            Discover the intersection of timeless craftsmanship and contemporary style.
                            Our latest drop features hand-selected pieces designed for the modern purist.
                        </p>
                    </div>
                </Container>
            </section>

            {/* Sticky Filter Container */}
            <div className="filter-container border-bottom">
                <Container>
                    <div className="filter-swiper-wrap" data-aos="fade-up">
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={15}
                            freeMode={true}
                            modules={[FreeMode]}
                            className="filter-pills-swiper"
                        >
                            {categories.map((cat) => (
                                <SwiperSlide key={cat} style={{ width: 'auto' }}>
                                    <button
                                        className={`filter-btn ${filter === cat ? 'active' : ''}`}
                                        onClick={() => setFilter(cat)}
                                    >
                                        {cat}
                                    </button>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </Container>
            </div>

            {/* Product Grid Section */}
            <section className="arrival-grid">
                <Container>
                    <div className="section-header text-center mb-5" data-aos="fade-up">
                        <h2 className="title-md fw-bold mb-2">JUST LANDED</h2>
                        <p className="text-muted small letter-spacing-2">EXPLORE THE CURATED EDIT</p>
                    </div>

                    <Row className="g-3 g-md-5">
                        {filteredProducts.map((item, index) => (
                            <Col key={item.id} lg={3} md={4} xs={6}>
                                <div className="modern-card" onClick={() => navigate(`/product/${item.id}`)} style={{ cursor: 'pointer' }}>
                                    <div className="card-img-wrapper">
                                        <button
                                            className={`wishlist_btn ${isInWishlist(item.id) ? 'active' : ''}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleWishlist(item);
                                            }}
                                        >
                                            {isInWishlist(item.id) ? <FaHeart /> : <FaRegHeart />}
                                        </button>
                                        <div className="new-badge">New</div>
                                        <img src={item.productImage} alt={item.title} />
                                        <div className="glossy-reveal">
                                            <button className="btn btn-dark rounded-0 px-4 py-2 small">Quick View</button>
                                        </div>
                                    </div>
                                    <div className="card-details">
                                        <span className="card-cat">{item.category}</span>
                                        <h3 className="card-name">{item.title}</h3>
                                        <span className="card-price">${item.price}</span>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Lookbook / Glossy Section */}
            <section className="lookbook-section" data-aos="fade-up">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={6} className="mb-4 mb-lg-0">
                            <div className="lookbook-text p-md-5">
                                <span className="text-muted small mb-3 d-block letter-spacing-5">SEASONAL EDIT</span>
                                <h2 className="title-xl fw-bold mb-4">THE ART OF <br />CLASSIC MINIMALISM</h2>
                                <p className="mb-5">
                                    This season, we explore the depth of neutral tones and structural silhouettes.
                                    Every piece in the New Arrivals collection is a testament to our commitment
                                    to quality and effortless elegance.
                                </p>
                                <button className="btn btn-outline-dark px-5 py-3 rounded-0 fw-bold">VIEW LOOKBOOK</button>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="lookbook-wrap">
                                <img src="/images/card-6.jpeg" alt="Lookbook" className="lookbook-img" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Matte Newsletter Section */}
            <section className="newsletter-section py-5 text-center bg-white">
                <Container className="py-5">
                    <div className="col-lg-7 mx-auto" data-aos="zoom-in">
                        <h2 className="title-md fw-bold mb-3">GET RED CARPET READY</h2>
                        <p className="text-muted mb-4">Join our inner circle for exclusive early access to new drops and private sales.</p>
                        <div className="d-flex gap-2 justify-content-center flex-sm-row flex-column">
                            <input type="email" placeholder="Your email address" className="form-control rounded-0 px-4 py-3 border-dark" style={{ maxWidth: '400px' }} />
                            <button className="btn btn-dark rounded-0 px-5">SUBSCRIBE</button>
                        </div>
                    </div>
                </Container>
            </section>
        </div>
    );
};

export default NewArrivals;
